// extracted by mini-css-extract-plugin
export var displayNone = "_v4-6";
export var imgContainer = "_v4-2";
export var overflowHidden = "_v4-3";
export var productInfoCardButtonContainer = "_v4-5";
export var productTitleText = "_v4-4";
export var rightArrow = "_v4-1";
export var rightArrowContainer = "_v4-0";